import { Chip } from "@mui/material";

import "./TeacherBadge.css";

function TeacherBadge() {
  return <Chip className="teacher-badge" label="Вчителька" size="small" />;
}

export default TeacherBadge;
